import { cartMuiTheme } from '@cart/ui/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import tw, { styled } from 'twin.macro'

export const StyledIcon = styled(FontAwesomeIcon)(({ color, height }) => [
  !height ? tw`h-6` : `height: ${typeof height === 'number' ? `${height}px` : height};`,
  `color:${color || cartMuiTheme.palette.action.active}`,
])
